import { Record, Union } from "./fable_modules/fable-library.4.10.0/Types.js";
import { getRecordField, getUnionFields, isUnion, obj_type, getRecordElements, name as name_1, record_type, option_type, class_type, array_type, string_type, list_type, anonRecord_type, int32_type, union_type } from "./fable_modules/fable-library.4.10.0/Reflection.js";
import { SlipAnswer__ToRawString, AudModels_QuizCard__get_Msg, TourCard__SecondsLeft_7F9DDECF, AudModels_QuizCard, TourCard__IsCountdownActive_7F9DDECF, QuizStatus, AudModels_HistoryRecord_$reflection, QuizChangedEvent_$reflection, RESP$1_$reflection, AudModels_QuizCard_$reflection } from "../shared/Shared.fs.js";
import { equals } from "./fable_modules/fable-library.4.10.0/Util.js";
import { splitByLines, timeDiff, apiCmd, batchCmd, timeoutCmd, noCmd, serverTime as serverTime_1 } from "./Common.fs.js";
import { Cmd_ofEffect } from "./fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { configure, subscribe as subscribe_1 } from "./AppSync.fs.js";
import { reverse, indexed, length, singleton as singleton_1, empty } from "./fable_modules/fable-library.4.10.0/List.js";
import { tryFind } from "./fable_modules/fable-library.4.10.0/Array.js";
import { FSharpResult$2 } from "./fable_modules/fable-library.4.10.0/Choice.js";
import { HTMLAttr } from "./fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { collect, map, empty as empty_1, singleton, append, delay, toList } from "./fable_modules/fable-library.4.10.0/Seq.js";
import { mediaEl, singleTourInfo, playFooter, resultsViewEmb, playQuiz, playTitle } from "./MainTemplates.fs.js";
import * as react from "react";
import { Fa_IconOption, Fa_i } from "./fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { keyValueList } from "./fable_modules/fable-library.4.10.0/MapUtil.js";
import { Icons_grin } from "./IconHelpers.fs.js";
import { split, printf, toText } from "./fable_modules/fable-library.4.10.0/String.js";

export class Tab extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["History", "Question", "Results"];
    }
}

export function Tab_$reflection() {
    return union_type("Aud.Tab", [], Tab, () => [[], [], []]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["GetQuizRsp", "ChangeTab", "QuizChanged", "CountdownTick", "GetHistoryResp", "ConnectionErrors", "Exn"];
    }
}

export function Msg_$reflection() {
    return union_type("Aud.Msg", [], Msg, () => [[["Item", RESP$1_$reflection(AudModels_QuizCard_$reflection())]], [["Item", Tab_$reflection()]], [["Item", QuizChangedEvent_$reflection()]], [["Item", anonRecord_type(["QwIndex", int32_type])]], [["Item", RESP$1_$reflection(list_type(AudModels_HistoryRecord_$reflection()))]], [["Item", array_type(string_type)]], [["Item", class_type("System.Exception")]]]);
}

export class Model extends Record {
    constructor(Quiz, ActiveTab, Error$, TimeDiff, History) {
        super();
        this.Quiz = Quiz;
        this.ActiveTab = ActiveTab;
        this.Error = Error$;
        this.TimeDiff = TimeDiff;
        this.History = History;
    }
}

export function Model_$reflection() {
    return record_type("Aud.Model", [], Model, () => [["Quiz", option_type(AudModels_QuizCard_$reflection())], ["ActiveTab", Tab_$reflection()], ["Error", string_type], ["TimeDiff", class_type("System.TimeSpan")], ["History", list_type(AudModels_HistoryRecord_$reflection())]]);
}

export function Model__get_CurrentQuestion(x) {
    const matchValue = x.Quiz;
    if (matchValue == null) {
        return void 0;
    }
    else {
        return matchValue.TC;
    }
}

export function Model__get_IsCountdownActive(x) {
    const matchValue = x.Quiz;
    if (matchValue == null) {
        return false;
    }
    else {
        const quiz = matchValue;
        const matchValue_1 = quiz.TC;
        if (matchValue_1 == null) {
            return false;
        }
        else {
            const qw = matchValue_1;
            if (equals(quiz.QS, new QuizStatus(1, []))) {
                return TourCard__IsCountdownActive_7F9DDECF(qw, serverTime_1(x.TimeDiff));
            }
            else {
                return false;
            }
        }
    }
}

export function error(txt, model) {
    return new Model(model.Quiz, model.ActiveTab, txt, model.TimeDiff, model.History);
}

export function ok(model) {
    return new Model(model.Quiz, model.ActiveTab, "", model.TimeDiff, model.History);
}

export function subscribe(quizId, model) {
    const matchValue = model.Quiz;
    if (matchValue == null) {
        return noCmd(model);
    }
    else {
        const quiz = matchValue;
        return [model, Cmd_ofEffect((dispatch) => {
            subscribe_1(quizId, quiz.LT, (arg) => {
                dispatch(new Msg(2, [arg]));
            }, (arg_1) => {
                dispatch(new Msg(5, [arg_1]));
            });
        })];
    }
}

export function setupCountdown(model, cmd) {
    let tupledArg;
    if (Model__get_IsCountdownActive(model)) {
        const matchValue_1 = Model__get_CurrentQuestion(model);
        tupledArg = ((matchValue_1 == null) ? noCmd(model) : [model, timeoutCmd(new Msg(3, [{
            QwIndex: matchValue_1.Idx,
        }]), 1000)]);
    }
    else {
        tupledArg = noCmd(model);
    }
    return batchCmd(cmd, tupledArg[0], tupledArg[1]);
}

export function updateQuiz(f, model) {
    const matchValue = model.Quiz;
    if (matchValue == null) {
        return model;
    }
    else {
        return new Model(f(matchValue), model.ActiveTab, model.Error, model.TimeDiff, model.History);
    }
}

export function init(api, user) {
    configure(user.AppSyncCfg.Endpoint, user.AppSyncCfg.Region, user.AppSyncCfg.ApiKey);
    return apiCmd(api.getQuiz, void 0, (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(6, [Item_1])), new Model(void 0, new Tab(1, []), "", 0, empty()));
}

export function update(api, user, msg, cm) {
    let matchResult, res_4, st, evt, res_5, txt_4, ex;
    switch (msg.tag) {
        case 0: {
            if (msg.fields[0].Value.tag === 0) {
                matchResult = 0;
                res_4 = msg.fields[0].Value.fields[0];
                st = msg.fields[0].ST;
            }
            else {
                let activePatternResult;
                const msg_1 = msg;
                const pi_1 = tryFind((pi) => (name_1(pi) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1 == null) {
                    activePatternResult = void 0;
                }
                else {
                    const pi$0027 = pi_1;
                    let msgType;
                    let copyOfStruct = msg_1;
                    msgType = Msg_$reflection();
                    if (isUnion(msgType)) {
                        const objArray = getUnionFields(msg_1, msgType)[1];
                        if (objArray.length === 1) {
                            try {
                                const patternInput_1 = getUnionFields(getRecordField(objArray[0], pi$0027), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult = ((name_1(patternInput_1[0]) === "Error") ? patternInput_1[1][0] : void 0);
                            }
                            catch (matchValue) {
                                activePatternResult = void 0;
                            }
                        }
                        else {
                            activePatternResult = void 0;
                        }
                    }
                    else {
                        activePatternResult = void 0;
                    }
                }
                if (activePatternResult != null) {
                    matchResult = 7;
                    txt_4 = activePatternResult;
                }
                else {
                    matchResult = 9;
                }
            }
            break;
        }
        case 3: {
            matchResult = 1;
            break;
        }
        case 2: {
            matchResult = 2;
            evt = msg.fields[0];
            break;
        }
        case 1: {
            switch (msg.fields[0].tag) {
                case 0: {
                    matchResult = 4;
                    break;
                }
                case 2: {
                    matchResult = 5;
                    break;
                }
                default:
                    matchResult = 3;
            }
            break;
        }
        case 4: {
            if (msg.fields[0].Value.tag === 0) {
                matchResult = 6;
                res_5 = msg.fields[0].Value.fields[0];
            }
            else {
                let activePatternResult_1;
                const msg_2 = msg;
                const pi_1_1 = tryFind((pi_2) => (name_1(pi_2) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1_1 == null) {
                    activePatternResult_1 = void 0;
                }
                else {
                    const pi$0027_1 = pi_1_1;
                    let msgType_1;
                    let copyOfStruct_1 = msg_2;
                    msgType_1 = Msg_$reflection();
                    if (isUnion(msgType_1)) {
                        const objArray_2 = getUnionFields(msg_2, msgType_1)[1];
                        if (objArray_2.length === 1) {
                            try {
                                const patternInput_1_1 = getUnionFields(getRecordField(objArray_2[0], pi$0027_1), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult_1 = ((name_1(patternInput_1_1[0]) === "Error") ? patternInput_1_1[1][0] : void 0);
                            }
                            catch (matchValue_1) {
                                activePatternResult_1 = void 0;
                            }
                        }
                        else {
                            activePatternResult_1 = void 0;
                        }
                    }
                    else {
                        activePatternResult_1 = void 0;
                    }
                }
                if (activePatternResult_1 != null) {
                    matchResult = 7;
                    txt_4 = activePatternResult_1;
                }
                else {
                    matchResult = 9;
                }
            }
            break;
        }
        case 6: {
            let activePatternResult_2;
            const msg_3 = msg;
            const pi_1_2 = tryFind((pi_3) => (name_1(pi_3) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
            if (pi_1_2 == null) {
                activePatternResult_2 = void 0;
            }
            else {
                const pi$0027_2 = pi_1_2;
                let msgType_2;
                let copyOfStruct_2 = msg_3;
                msgType_2 = Msg_$reflection();
                if (isUnion(msgType_2)) {
                    const objArray_3 = getUnionFields(msg_3, msgType_2)[1];
                    if (objArray_3.length === 1) {
                        try {
                            const patternInput_1_2 = getUnionFields(getRecordField(objArray_3[0], pi$0027_2), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                            activePatternResult_2 = ((name_1(patternInput_1_2[0]) === "Error") ? patternInput_1_2[1][0] : void 0);
                        }
                        catch (matchValue_2) {
                            activePatternResult_2 = void 0;
                        }
                    }
                    else {
                        activePatternResult_2 = void 0;
                    }
                }
                else {
                    activePatternResult_2 = void 0;
                }
            }
            if (activePatternResult_2 != null) {
                matchResult = 7;
                txt_4 = activePatternResult_2;
            }
            else {
                matchResult = 8;
                ex = msg.fields[0];
            }
            break;
        }
        default: {
            let activePatternResult_3;
            const msg_4 = msg;
            const pi_1_3 = tryFind((pi_4) => (name_1(pi_4) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
            if (pi_1_3 == null) {
                activePatternResult_3 = void 0;
            }
            else {
                const pi$0027_3 = pi_1_3;
                let msgType_3;
                let copyOfStruct_3 = msg_4;
                msgType_3 = Msg_$reflection();
                if (isUnion(msgType_3)) {
                    const objArray_4 = getUnionFields(msg_4, msgType_3)[1];
                    if (objArray_4.length === 1) {
                        try {
                            const patternInput_1_3 = getUnionFields(getRecordField(objArray_4[0], pi$0027_3), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                            activePatternResult_3 = ((name_1(patternInput_1_3[0]) === "Error") ? patternInput_1_3[1][0] : void 0);
                        }
                        catch (matchValue_3) {
                            activePatternResult_3 = void 0;
                        }
                    }
                    else {
                        activePatternResult_3 = void 0;
                    }
                }
                else {
                    activePatternResult_3 = void 0;
                }
            }
            if (activePatternResult_3 != null) {
                matchResult = 7;
                txt_4 = activePatternResult_3;
            }
            else {
                matchResult = 9;
            }
        }
    }
    switch (matchResult) {
        case 0: {
            const tupledArg = subscribe(user.QuizId, new Model(res_4, cm.ActiveTab, cm.Error, timeDiff(st), cm.History));
            return setupCountdown(tupledArg[0], tupledArg[1]);
        }
        case 1: {
            const tupledArg_1 = noCmd(cm);
            return setupCountdown(tupledArg_1[0], tupledArg_1[1]);
        }
        case 2: {
            const tupledArg_2 = noCmd(updateQuiz((quiz) => (new AudModels_QuizCard(evt.QS, quiz.QN, quiz.Img, quiz.Wcm, quiz.Fwl, evt.T, quiz.LT, quiz.RT, quiz.Mxlr, evt.Url, quiz.V)), cm));
            return setupCountdown(tupledArg_2[0], tupledArg_2[1]);
        }
        case 3:
            return noCmd(ok(new Model(cm.Quiz, new Tab(1, []), cm.Error, cm.TimeDiff, cm.History)));
        case 4:
            return apiCmd(api.getHistory, void 0, (Item) => (new Msg(4, [Item])), (Item_1) => (new Msg(6, [Item_1])), ok(new Model(cm.Quiz, new Tab(0, []), cm.Error, cm.TimeDiff, cm.History)));
        case 5:
            return noCmd(ok(new Model(cm.Quiz, new Tab(2, []), cm.Error, cm.TimeDiff, cm.History)));
        case 6:
            return noCmd(new Model(cm.Quiz, cm.ActiveTab, cm.Error, cm.TimeDiff, res_5));
        case 7:
            return noCmd(error(txt_4, cm));
        case 8:
            return noCmd(error(ex.message, cm));
        default:
            return noCmd(cm);
    }
}

export function view(dispatch, settings, model, user, l10n) {
    const matchValue = model.Quiz;
    if (matchValue == null) {
        if (model.Error === "") {
            return "Initializing...";
        }
        else {
            return model.Error;
        }
    }
    else {
        return quizView(dispatch, settings, model, user.QuizId, matchValue, l10n);
    }
}

export function quizView(dispatch, settings, model, quizId, quiz, l10n) {
    let props_12, children_12, props_6, children_6, props_10;
    const serverTime = serverTime_1(model.TimeDiff);
    let patternInput;
    const matchValue = quiz.TC;
    if (matchValue == null) {
        patternInput = [0, false];
    }
    else {
        const q = matchValue;
        patternInput = [TourCard__SecondsLeft_7F9DDECF(q, serverTime), TourCard__IsCountdownActive_7F9DDECF(q, serverTime)];
    }
    const props_14 = [["style", {
        width: "100%",
        height: "100%",
        minWidth: "375px",
        textAlign: "center",
        position: "relative",
    }]];
    const children_14 = [(props_12 = [["style", {
        overflowY: "auto",
        position: "absolute",
        top: "0",
        width: "100%",
    }]], (children_12 = [(props_6 = [new HTMLAttr(65, ["container"]), ["style", {
        maxWidth: "800px",
    }]], (children_6 = toList(delay(() => append(singleton(playTitle(settings.MediaHost, quiz.Img, quiz.Mxlr, quiz.Url)), delay(() => append(singleton(react.createElement("h3", {
        className: "title is-3",
    }, quiz.QN)), delay(() => {
        let children_4, children_2;
        return append(singleton((children_4 = [(children_2 = [Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-users"])), []), " " + l10n.Audience], react.createElement("span", {}, ...children_2))], react.createElement("h4", {
            className: "subtitle is-4",
        }, ...children_4))), delay(() => {
            const matchValue_1 = model.ActiveTab;
            switch (matchValue_1.tag) {
                case 1:
                    if (quiz.QS.tag === 1) {
                        const matchValue_3 = quiz.TC;
                        if (matchValue_3 == null) {
                            return empty_1();
                        }
                        else {
                            const tour = matchValue_3;
                            const matchValue_4 = tour.Slip;
                            return (matchValue_4.tag === 1) ? singleton(multipleQwView(settings, tour, matchValue_4.fields[0], matchValue_4.fields[1], l10n)) : singleton(singleQwView(settings, tour, matchValue_4.fields[0], l10n));
                        }
                    }
                    else {
                        return singleton(playQuiz(quiz.QS, AudModels_QuizCard__get_Msg(quiz), l10n.Common));
                    }
                case 2:
                    return singleton(resultsViewEmb(quizId)(quiz.RT)(void 0)(settings.MediaHost));
                default:
                    return singleton(historyView(dispatch, model, l10n));
            }
        }));
    })))))), react.createElement("div", keyValueList(props_6, 1), ...children_6))), react.createElement("p", {
        className: "help is-danger",
    }, model.Error), (props_10 = [["style", {
        height: "66px",
    }]], react.createElement("div", keyValueList(props_10, 1)))], react.createElement("div", keyValueList(props_12, 1), ...children_12))), playFooter((arg) => {
        dispatch(new Msg(1, [arg]));
    }, new Tab(0, []), new Tab(1, []), new Tab(2, []), model.ActiveTab, patternInput[1], patternInput[0], l10n.Common)];
    return react.createElement("div", keyValueList(props_14, 1), ...children_14);
}

export function singleQwView(settings, tour, slip, l10n) {
    const children_26 = toList(delay(() => append(singleton(singleTourInfo(settings.MediaHost, tour.Name, slip, l10n.Common)), delay(() => {
        const matchValue = slip;
        switch (matchValue.tag) {
            case 1: {
                const matchValue_1 = matchValue.fields[0].Choices;
                if (matchValue_1 != null) {
                    const list = matchValue_1;
                    return append(singleton(react.createElement("br", {})), delay(() => {
                        let children_10, children_8, children_6;
                        return singleton((children_10 = [(children_8 = [(children_6 = toList(delay(() => map((ch) => {
                            let children_2;
                            const children_4 = [(children_2 = [react.createElement("a", {
                                className: "button is-fullwidth",
                            }, ch)], react.createElement("div", {
                                className: "control has-icons-left has-icons-right",
                            }, ...children_2)), react.createElement("br", {})];
                            return react.createElement("li", {}, ...children_4);
                        }, list))), react.createElement("ul", {}, ...children_6))], react.createElement("div", {
                            className: "column is-half mx-3",
                        }, ...children_8))], react.createElement("div", {
                            className: "columns is-centered",
                        }, ...children_10)));
                    }));
                }
                else {
                    return empty_1();
                }
            }
            case 2: {
                const matchValue_2 = matchValue.fields[0].Aw;
                if (matchValue_2.tag === 1) {
                    return append(singleton(react.createElement("br", {})), delay(() => {
                        let children_24, children_22, children_20;
                        return singleton((children_24 = [(children_22 = [(children_20 = toList(delay(() => map((ch_1) => {
                            let children_16;
                            const children_18 = [(children_16 = toList(delay(() => append(singleton(react.createElement("a", {
                                className: "button is-fullwidth",
                            }, ch_1.Text)), delay(() => {
                                let children_14;
                                return ch_1.IsCorrect ? singleton((children_14 = [Fa_i(singleton_1(Icons_grin), [])], react.createElement("span", {
                                    className: "icon is-large is-left has-text-black",
                                }, ...children_14))) : empty_1();
                            })))), react.createElement("div", {
                                className: "control has-icons-left",
                            }, ...children_16)), react.createElement("br", {})];
                            return react.createElement("li", {}, ...children_18);
                        }, matchValue_2.fields[0]))), react.createElement("ul", {}, ...children_20))], react.createElement("div", {
                            className: "column is-half mx-3",
                        }, ...children_22))], react.createElement("div", {
                            className: "columns is-centered",
                        }, ...children_24)));
                    }));
                }
                else {
                    return empty_1();
                }
            }
            default: {
                return empty_1();
            }
        }
    }))));
    return react.createElement("div", {}, ...children_26);
}

export function multipleQwView(settings, tour, name, slips, l10n) {
    const lastIdx = (length(slips) - 1) | 0;
    const children_12 = toList(delay(() => append(singleton(react.createElement("h5", {
        className: "subtitle is-5",
    }, name)), delay(() => collect((matchValue) => {
        let children_6, arg_5, children_2, arg_2;
        const idx = matchValue[0] | 0;
        const isPlaying = idx === lastIdx;
        const matchValue_1 = matchValue[1];
        switch (matchValue_1.tag) {
            case 2: {
                const slip_2 = matchValue_1.fields[0];
                return append(singleton((children_6 = [(arg_5 = ((idx + 1) | 0), toText(printf("%s %s.%i"))(l10n.Question)(tour.Name)(arg_5))], react.createElement("p", {
                    className: "has-text-weight-semibold",
                }, ...children_6))), delay(() => {
                    let children_8;
                    return append(singleton((children_8 = [l10n.CorrectAnswer + ": ", split(SlipAnswer__ToRawString(slip_2.Aw), ["\n"], void 0, 0)[0]], react.createElement("p", {
                        className: "has-text-weight-light is-family-secondary is-size-6",
                    }, ...children_8))), delay(() => append(mediaEl(settings.MediaHost, slip_2.Media, isPlaying), delay(() => {
                        let children_10;
                        return append(singleton((children_10 = splitByLines(slip_2.Com), react.createElement("p", {
                            className: "is-italic has-text-weight-light is-family-secondary is-size-7",
                        }, ...children_10))), delay(() => singleton(react.createElement("br", {}))));
                    }))));
                }));
            }
            case 0:
                return singleton("x3");
            default: {
                const slip_1 = matchValue_1.fields[0];
                return append(singleton((children_2 = [(arg_2 = ((idx + 1) | 0), toText(printf("%s %s.%i"))(l10n.Question)(tour.Name)(arg_2))], react.createElement("p", {
                    className: "has-text-weight-semibold",
                }, ...children_2))), delay(() => append(mediaEl(settings.MediaHost, slip_1.Media, isPlaying), delay(() => {
                    let children_4;
                    return append(singleton((children_4 = splitByLines(slip_1.Txt), react.createElement("p", {}, ...children_4))), delay(() => append(singleton(react.createElement("br", {})), delay(() => singleton(react.createElement("br", {}))))));
                }))));
            }
        }
    }, indexed(slips))))));
    return react.createElement("div", {}, ...children_12);
}

export function historyView(dispatch, model, l10n) {
    let children_8, children_6, props, children_22;
    const children_24 = [(children_8 = [(children_6 = [(props = [["style", {
        width: "30px",
    }]], react.createElement("th", keyValueList(props, 1), "#")), react.createElement("th", {}, l10n.CorrectAnswers), react.createElement("th", {}, "")], react.createElement("tr", {}, ...children_6))], react.createElement("thead", {}, ...children_8)), (children_22 = toList(delay(() => map((aw) => {
        let children_12, children_16, children_14;
        const children_20 = [(children_12 = [react.createElement("p", {}, aw.QwName)], react.createElement("td", {}, ...children_12)), (children_16 = [(children_14 = [split(aw.QwAw, ["\n"], void 0, 0)[0]], react.createElement("p", {
            className: "is-italic",
        }, ...children_14))], react.createElement("td", {}, ...children_16)), react.createElement("td", {})];
        return react.createElement("tr", {}, ...children_20);
    }, reverse(model.History)))), react.createElement("tbody", {}, ...children_22))];
    return react.createElement("table", {
        className: "table is-hoverable is-fullwidth",
    }, ...children_24);
}

